// SM permissions
export const VIEW_SM_APP = "view:sm-app";
export const READ_PARTICIPANT = "read:participant";
export const READ_PARTICIPANT_TASK = "read:participant_task";
export const READ_OUTREACH = "read:outreach";
export const READ_SURVEY = "read:survey";
export const EDIT_PARTICIPANT_DATA_UPLOAD = "edit:participant_data_upload";
export const EDIT_INCENTIVE = "edit:incentive";
export const EDIT_TISSUE = "edit:tissue";
export const EDIT_SURVEY = "edit:survey";
export const EDIT_OUTREACH_TEMPLATE = "edit:outreach_template";
export const CREATE_OUTREACH_TEMPLATE = "create:outreach_template";
export const EDIT_WORKFLOW_PERMISSION = "edit:workflow";
export const VIEW_WORKFLOW_EDITOR_PERMISSION = "view:workflow-editor";
export const MANAGE_AGENTS = "manage:agents";
export const ADMIN_SM = "admin:sm";
export const TEST_BROADCAST = "test:broadcast";
